import { Box, Stack } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { useDispatch, useSelector } from "react-redux";

import { Color, FontStyle, JobDisplays } from "../constants";
import { getExperienceTag, JobTag } from "../utils/jobUtils";
import { throttle } from "../utils/utils";
import * as apiService from "../service/ApiService";
import SparkleFX, { generateSparkle } from "./SparkleFX";

const styles = {
  favHeart: {
    cursor: "pointer",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    backgroundColor: "transparent !important",
    "&:hover": {
      // stroke: "#000",
      // strokeWidth: 1,
      // boxShadow: "0px 0px 12px #150BD9",
      // backgroundColor: "transparent !important",
      // background: "radial-gradient(#e66465, #9198e500);",
    },
    // zIndex: 201,
    "&:active": {
      transform: "scale(0.9)",
    },
  },
};

const FavHeartContainer = ({ fav, setFav, jobId, rightOffset = null }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const [hovered, setHovered] = useState(false);
  const [sparkles, setSparkles] = useState([]);
  useEffect(() => {
    if (fav) {
      const newSparkle = generateSparkle();
      setSparkles((s) => [...s, newSparkle]);
      setTimeout(() => {
        setSparkles((s) => s.filter((sparkle) => sparkle.id !== newSparkle.id));
      }, 3000);
    }
  }, [fav]);
  const toggleFav = (event) => {
    setFav((fav) => {
      // if this is adding to favs, make a sparkle effect
      // if (!fav) {
      //   const newSparkle = generateSparkle();
      //   setSparkles((s) => [...s, newSparkle]);
      //   setTimeout(() => {
      //     setSparkles((s) =>
      //       s.filter((sparkle) => sparkle.id !== newSparkle.id)
      //     );
      //   }, 3000);
      // }
      // api call to toggle fav (this will also dispatch to global state)
      apiService.toggleFavJob(dispatch, {
        ...auth.accountData,
        jobId,
        isFav: !fav,
      });
      // return the new fav state, for local state
      return !fav;
    });
  };
  const throttledToggleFav = useCallback(throttle(toggleFav, 800), []);
  const handleClick = (e) => {
    e.stopPropagation();
    throttledToggleFav(e);
  };
  return (
    <Box
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onClick={handleClick}
      sx={{
        // position: "absolute",
        // top: JobDisplays.padding,
        // right: rightOffset !== null ? rightOffset : JobDisplays.padding,
        width: "24px",
        height: "24px",
        backgroundColor: "transparent",
        position: "relative",
        // "&:hover": {
        //   boxShadow: "0px 0px 12px #150BD9",
        // },
      }}>
      {/* {sparkles && SparkleFX(sparkle)} */}
      {sparkles.map((sparkle, i) => (
        <SparkleFX key={i} {...sparkle} />
      ))}
      {fav ? (
        hovered ? (
          <>
            <svg width={0} height={0}>
              <linearGradient id="linearColorsGray" x1={1} y1={0} x2={1} y2={1}>
                <stop offset={0} stopColor="#EB7783" />
                <stop offset={1} stopColor="#f45c4380" />
              </linearGradient>
            </svg>
            <FavoriteIcon
              sx={{ ...styles.favHeart, fill: "url(#linearColorsGray)" }}
            />
          </>
        ) : (
          <>
            <svg width={0} height={0}>
              <linearGradient id="linearColorsRed" x1={1} y1={0} x2={1} y2={1}>
                <stop offset={0} stopColor="#eb3349" />
                <stop offset={1} stopColor="#f45c43" />
              </linearGradient>
            </svg>
            <FavoriteIcon
              sx={{ ...styles.favHeart, fill: "url(#linearColorsRed)" }}
            />
          </>
        )
      ) : hovered ? (
        <>
          <svg width={0} height={0}>
            <linearGradient id="linearColorsPink" x1={1} y1={0} x2={1} y2={1}>
              <stop offset={0} stopColor="#EB7783" />
              <stop offset={1} stopColor="#f45c43" />
            </linearGradient>
          </svg>
          <FavoriteBorderIcon
            sx={{ ...styles.favHeart, fill: "url(#linearColorsPink)" }}
          />
        </>
      ) : (
        <FavoriteBorderIcon sx={{ ...styles.favHeart, color: "#aaa" }} />
      )}
    </Box>
  );
};

export default FavHeartContainer;
